
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-executivo",
      function () {
        return require("private-next-pages/material-executivo.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-executivo"])
      });
    }
  